import * as React from "react";

import "./office-mailing-assets-route.scss";

import {Redirect} from "react-router-dom";

import {cs}                 from "@Common/react/chain-services";
import {consumeContext}     from "@Common/react/context";
import {Invoke}             from "@Common/react/invoke";
import {Load2}              from "@Common/react/load2";
import {parseUrlQuery}      from "@Common/utils/parse-url-query";

import {BRANCH_LEVEL}               from "@Xpresso/routes/common/logic/user-level";
import {DoNotMailSection}           from "@Xpresso/routes/account/office/address-book-route/do-not-mail/do-not-mail-section";
import {SampleAddressSection}       from "@Xpresso/routes/account/common/sample-address/sample-address";
import {bulkMailPermitIsAllowed}    from "@Xpresso/routes/account/common/bulk-mail-permit/bulk-mail-permit";
import {convertAddressBookSection}  from "@Xpresso/routes/account/office/address-book-route/address-book-route";

import {OfficeAdminLayout}  from "../common/office-admin-layout";
import {Context}            from "../common/office-admin-layout-loader";

import {BulkMailPermitCard}         from "./bulk-mail-permit-card";
import {IntelligentMailBarcodeCard} from "./intelligent-mail-barcode-card";

export const OfficeMailingAssetsRoute = () => cs(
    consumeContext("routerHistory"),
    ["officeId", ({}, next) => next(
        parseUrlQuery(window.location.search)?.office || parseUrlQuery(window.location.search)?.branch
    )],
    ({officeId}, next) => (
        !officeId ? (
            <Redirect to="/account/admin/office"/>
        ) : (
            next()
        )
    ),
    ["loader", (_, next) => (
        <Context.Consumer>
            {next}
        </Context.Consumer>
    )],
    ["data", ({loader, officeId}, next) => loader.loadData({officeId, next})],
    ({data, routerHistory}, next) => (
        (data.loading || data?.office?.idBranch) ? (
            next()
        ) : (
            Invoke({action: () => {
                data.clear();
                routerHistory.replace("/account/admin/office");
            }})
        )
    ),
    ["office", ({data}, next) => next(data.office)],
    ({office, officeId, data}, next) => OfficeAdminLayout({activeTab: "office-mailing-assets", office, officeId, reload: data.reload, next}),
    consumeContext("company"),
    consumeContext("session"),
    consumeContext("userLevels"),
    ["permitActive", ({userLevels, company, session}, next) => next(
        bulkMailPermitIsAllowed(userLevels.userLevel, company, session)
    )],
    consumeContext("userLevels"),
    ["userLevel", ({userLevels}, next) => next(
        userLevels?.userLevel
    )],
    consumeContext("apis"),
    ["bulkMailPermit", ({apis, officeId, permitActive}, next) => Load2({
        fetch: () => permitActive ? apis.next.bulkMailPermit.getIndica({agentId: officeId, userLevel: BRANCH_LEVEL}) : null,
        next,
    })],
    ["intelligentMailBarcode", ({apis, officeId}, next) => Load2({
        fetch: () => apis.next.imb.getMailerId({agentId: officeId}),
        next,
    })],
    ["dnmSection", ({}, next) => DoNotMailSection({next})],
    ["sampleAddressSection", ({officeId}, next) => convertAddressBookSection(
        ({next}) => SampleAddressSection({
            next,
            idEntity: officeId,
        })
    )({next})],
    ({
        bulkMailPermit,
        company,
        dnmSection,
        intelligentMailBarcode,
        office,
        officeId,
        permitActive,
        sampleAddressSection,
        userLevel,
    }) => (
        <div className="office-address-lists-HgS">
            {
                permitActive &&
                <BulkMailPermitCard officeId={officeId} userLevel={userLevel} bulkMailPermit={bulkMailPermit} />
            }
            <IntelligentMailBarcodeCard officeId={officeId} intelligentMailBarcode={intelligentMailBarcode} />
            {company && office && (((!office.prefs.hasOwnProperty("enableOfficeDnmList") || office.prefs.enableOfficeDnmList == 2) && company.prefs.enableOfficeDnmList == 1) || office.prefs.enableOfficeDnmList == 1) &&
                dnmSection.render()
            }
            {sampleAddressSection.render()}
        </div>
    )
)

